import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Link } from "react-router-dom";

const countries = [
  {
    name: "Study in USA",
    image: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=1200&q=80",
    href: "/study/usa",
  },
  {
    name: "Study in UK",
    image: "https://images.unsplash.com/photo-1488747279002-c8523379faaa?w=1200&q=80",
    href: "/study/uk",
  },
  {
    name: "Study in Australia",
    image: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=1200&q=80",
    href: "/study/australia",
  },
  {
    name: "Study in Canada",
    image: "https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=1200&q=80",
    href: "/study/canada",
  },
  {
    name: "Study in Germany",
    image: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=1200&q=80",
    href: "/study/germany",
  },
  {
    name: "Study in France",
    image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200&q=80",
    href: "/study/france",
  },
];

/* === SAME LOGIC AS WORKFLOW === */

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.35, // calm, premium
    },
  },
};

const cardVariants = {
  hidden: {
    opacity: 0,
    y: 50,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

export default function CountriesWeServe() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="w-full overflow-hidden bg-white">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        className="
          grid grid-cols-1
          sm:grid-cols-2
          lg:grid-cols-3
        "
      >
        {countries.map((country, index) => (
  <Link key={index} to={country.href}>
    <motion.div
      variants={cardVariants}
      className="
        relative h-[340px]
        overflow-hidden
        group
        cursor-pointer
      "
    >
      {/* IMAGE */}
      <img
        src={country.image}
        alt={country.name}
        className="
          absolute inset-0
          w-full h-full mx-auto
          object-cover
          transition-transform duration-700
          group-hover:scale-105
        "
      />

      {/* TEXT */}
      <div className="absolute bottom-8 left-8 z-10">
        <span className="block text-white/70 text-sm mb-1">
          {String(index + 1).padStart(2, "0")}.
        </span>
        <h3 className="text-white text-2xl font-semibold">
          {country.name}
        </h3>
      </div>

      {/* HOVER SHADE */}
      <div className="
        absolute inset-0
        bg-black/0
        group-hover:bg-black/15
        transition duration-500
      " />
    </motion.div>
  </Link>
))}

      </motion.div>
    </section>
  );
}
